import * as turf from '@turf/turf';
import { processGeojson } from 'kepler.gl/processors';
import { wrapTo, removeDataset } from 'kepler.gl/actions';
import { addDataToMap } from "kepler.gl/actions";

const ZONE_GEO_JSON_PATH = "/bbmp_zone_boundaries_243.geojson";

export const fetchAndProcessZoneGeoJSON = async (trafficInfractionList, municipalInfractionList, isReCalculateRequired, setLayerDataState, dispatch, store) => {
    let geojson;
    try {
        const response = await fetch(ZONE_GEO_JSON_PATH);
        if (!response.ok) {
            console.error('Invalid Zone GeoJSON data', response.statusText);
        }

        // Parse the JSON data
        geojson = await response.json();
        if (!geojson || !geojson.features) {
            console.error('Invalid Zone GeoJSON data');
        }

        // Create a new array to hold only Polygon features
        const newFeatures = [];

        geojson.features.forEach(feature => {
            // Only process Polygon and MultiPolygon features
            if (feature.geometry.type !== "Polygon" && feature.geometry.type !== "MultiPolygon") {
                return;
            }

            if (feature.geometry.type === "Polygon") {
                // Use existing coordinates directly
                const processedCoordinates = feature.geometry.coordinates;

                // Create a new Polygon feature with the same properties
                const newFeature = {
                    ...feature,
                    geometry: {
                        type: "Polygon",
                        coordinates: processedCoordinates
                    }
                };

                // Count infractions inside the polygon
                const polygon = turf.polygon(processedCoordinates);
                let infractionCount = 0;
                let municipalCount = 0;

                if (isReCalculateRequired && 
                    store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymjs")] &&
                    store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymjs")].config.isVisible) {
                    trafficInfractionList.forEach(infraction => {
                        const point = turf.point([infraction.position[0], infraction.position[1]]);
                        if (turf.booleanPointInPolygon(point, polygon)) {
                            infractionCount++;
                        }
                    });
                }

                if (isReCalculateRequired && 
                    store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymds")] && 
                    store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymds")].config.isVisible &&
                    store.getState().keplerGl.evidence.visState.datasets.municipal
                ) {
                    const municipalAllData = store.getState().keplerGl.evidence.visState.datasets.municipal.dataContainer._rows;

                    municipalInfractionList.forEach(infraction => {
                        const point = turf.point([municipalAllData[infraction.index][7], municipalAllData[infraction.index][6]]);
                        if (turf.booleanPointInPolygon(point, polygon)) {
                            municipalCount++;
                        }
                    });
                }

                newFeature.properties['Traffic Infraction Count'] = infractionCount;
                newFeature.properties['Municipal Infraction Count'] = municipalCount;
                newFeature.properties['Total Infraction Count'] = infractionCount + municipalCount;

                // Add to the new features array
                newFeatures.push(newFeature);

            } else if (feature.geometry.type === "MultiPolygon") {
                // For MultiPolygon, iterate over each polygon in the coordinates array
                feature.geometry.coordinates.forEach(polygonCoordinates => {
                    // Create a new geometry with type "Polygon" using the polygonCoordinates as is
                    const polygonGeometry = {
                        type: "Polygon",
                        coordinates: polygonCoordinates
                    };

                    // Clone the original feature to keep all other fields intact
                    const newFeature = JSON.parse(JSON.stringify(feature));
                    newFeature.geometry = polygonGeometry;

                     // Count infractions for this polygon
                    const polygon = turf.polygon(polygonCoordinates);
                    let infractionCount = 0;
                    let municipalCount = 0;

                    if (isReCalculateRequired && 
                        store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymjs")] && 
                        store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymjs")].config.isVisible) {
                        trafficInfractionList.forEach(infraction => {
                            const point = turf.point([infraction.position[0], infraction.position[1]]);
                            if (turf.booleanPointInPolygon(point, polygon)) {
                                infractionCount++;
                            }
                        });
                    }

                    if (isReCalculateRequired && 
                        store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymds")] && 
                        store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymds")].config.isVisible) {
                        const municipalAllData = store.getState().keplerGl.evidence.visState.datasets.municipal.dataContainer._rows;
                        municipalInfractionList.forEach(infraction => {
                            const point = turf.point([municipalAllData[infraction.index][7], municipalAllData[infraction.index][6]]);
                            if (turf.booleanPointInPolygon(point, polygon)) {
                                municipalCount++;
                            }
                        });
                    }

                    newFeature.properties['Traffic Infraction Count'] = infractionCount;
                    newFeature.properties['Municipal Infraction Count'] = municipalCount;
                    newFeature.properties['Total Infraction Count'] = infractionCount + municipalCount;

                    // Add the new Polygon feature to our array
                    newFeatures.push(newFeature);
                });
            }
        });

        // Replace original features with the new set of Polygon features
        geojson.features = newFeatures;
        console.log("Sujeet useSwr zone rawGeoJSON GeoJSON 3", geojson);
    } catch(error) {
        console.error('Error fetching zone GeoJSON data:', error);
    }
    setLayerDataState((prev) => ({ ...prev, zoneGeoJSON: geojson }));

    console.log("Sujeet zone ProcessedGeoJson : ", processGeojson(geojson));

    dispatch(wrapTo('evidence', removeDataset('zone')));

    dispatch(
        addDataToMap({
            datasets: [
                {
                    info: { label: "Zone", id: "zone" },
                    data: processGeojson(geojson)
                }
            ],
            options: {
                centerMap: false,
                readOnly: false,
                keepExistingConfig: true
            },
            config: {
                visState: {
                    interactionConfig: {
                        tooltip: {
                            id: 'tooltip',
                            enabled : true,
                            compareMode: false,
                            compareType: "absolute",
                            fieldsToShow: {
                                "zone": [
                                    {
                                        "name": "FID",
                                        "format": null
                                    },
                                    {
                                        "name": "Zone",
                                        "format": null
                                    },
                                    // {
                                    //     "name": "Traffic Infraction Count",
                                    //     "format": null
                                    // },
                                    // {
                                    //     "name": "Municipal Infraction Count",
                                    //     "format": null
                                    // }
                                ]
                            }
                        },
                        geocoder: {
                            enabled: true
                        }
                    },
                    layers: [
                        {
                            "id": "qoo6q2",
                            "type": "geojson",
                            "config": {
                            "dataId": "zone",
                            "columnMode": "geojson",
                            "label": "BBMP Zone",
                            "color": [
                                59,
                                133,
                                204
                            ],
                            "highlightColor": [
                                252,
                                242,
                                26,
                                255
                            ],
                            "columns": {
                                "geojson": "_geojson"
                            },
                            "isVisible": true,
                            "visConfig": {
                                "opacity": 0.02,
                                "strokeOpacity": 0.06,
                                "thickness": 1,
                                "strokeColor": [
                                    218,
                                    240,
                                    247
                                ],
                                "colorRange": {
                                    "name": "ColorBrewer YlOrBr-4",
                                    "type": "sequential",
                                    "category": "ColorBrewer",
                                    "colors": [
                                        "#E6FAFA",
                                        "#AAD7DA",
                                        "#68B4BB",
                                        "#00939C"
                                    ]
                                },
                                "strokeColorRange": {
                                    "name": "Global Warming",
                                    "type": "sequential",
                                    "category": "Uber",
                                    "colors": [
                                    "#4C0035",
                                    "#880030",
                                    "#B72F15",
                                    "#D6610A",
                                    "#EF9100",
                                    "#FFC300"
                                    ]
                                },
                                "radius": 10,
                                "sizeRange": [
                                0,
                                10
                                ],
                                "radiusRange": [
                                0,
                                50
                                ],
                                "heightRange": [
                                0,
                                500
                                ],
                                "elevationScale": 5,
                                "stroked": true,
                                "filled": true,
                                "enable3d": false,
                                "wireframe": false,
                                "fixedHeight": false
                            },
                            "hidden": false,
                            "textLabel": [
                                {
                                "field": null,
                                "color": [
                                    255,
                                    255,
                                    255
                                ],
                                "size": 18,
                                "offset": [
                                    0,
                                    0
                                ],
                                "anchor": "start",
                                "alignment": "center",
                                "outlineWidth": 0,
                                "outlineColor": [
                                    255,
                                    0,
                                    0,
                                    255
                                ],
                                "background": false,
                                "backgroundColor": [
                                    0,
                                    0,
                                    200,
                                    255
                                ]
                                }
                            ]
                            },
                            "visualChannels": {
                                "colorScale": "custom",
                                "strokeColorField": null,
                                "strokeColorScale": "quantile",
                                "sizeField": null,
                                "sizeScale": "linear",
                                "heightField": null,
                                "heightScale": "linear",
                                "radiusField": null,
                                "radiusScale": "linear"
                            }
                        }
                    ]
                }
            }
        })
    );

    console.log("Current Map zone Configuration wardGeoJson:", store.getState());

    console.log("Sujeet zone GeoJson useEffect end", geojson);
};